import React from "react";
import { Link } from "react-router-dom";
import { LEGAL_PATHS } from "../../legal/legalPaths";
import "./legal-components.css";

export default function CollectorRightsVaultCard() {
  return (
    <div className="td-rights-vault">
      <h3 className="td-rights-vault__title">License &amp; rights vault</h3>
      <nav className="td-rights-vault__links" aria-label="License terms shortcuts">
        <Link to={LEGAL_PATHS.nftComicMerchLicense}>
          <span>Genesis Comic NFT · merchandiser rights</span>
          <span aria-hidden>→</span>
        </Link>
        <Link to={LEGAL_PATHS.vrRealEstateTerms}>
          <span>VR Real Estate NFT · virtual property terms</span>
          <span aria-hidden>→</span>
        </Link>
        <Link to={LEGAL_PATHS.marketplaceSellerTerms}>
          <span>Marketplace storefront · seller terms</span>
          <span aria-hidden>→</span>
        </Link>
      </nav>
      <p className="td-rights-vault__hint">View Rights links open the covenant archive; they do not change your entitlements.</p>
    </div>
  );
}
